import './AgentCommissionBreakdown.scss';
import Component from './AgentCommissionBreakdown.js';
export default Component;
